module.exports = __webpack_public_path__ + "img/avatar4.8c39aa8d.png";